import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom'
import Register from './login/Register'
import Login from './login/Login'
import Direct  from './login/Direct'
import Frame from './Frame'
import './App.css';

class App extends Component<Props> {
    constructor(props) {
        super(props);
        localStorage.clear();
    }

    render() {
        return (
            <div>
                <div
                    className='tooltipremove'
                    id="tooltipremove"
                    style={{
                        position: 'absolute',
                        height: '15px',
                        width: '45px',
                        zIndex:99
                    }}
                >
                    <div className='tooltipremoveArrow'></div>
                    <span style={{top: '1px', position: 'absolute', width: '30px', marginLeft: '0px'}}>Remove</span>
                </div>
                <div
                    className='tooltipremoveLeft'
                    id="tooltipremoveLeft"
                    style={{
                        position: 'absolute',
                        height: '15px',
                        width: '45px',
                        zIndex:99
                    }}
                >
                    <div className='tooltipremoveArrowLeft'></div>
                    <span style={{top: '1px', position: 'absolute', width: '30px', marginLeft: '0px'}}>Remove</span>
                </div>
                <Router>
                    <div>
                        <Route exact path="/frame">
                            <div>
                                <Frame/>
                            </div>
                        </Route>
                    </div>
                    <div>
                        <div className="Outter" rmthumb="1">
                            <div className="App">
                                <Route exact path="/">
                                    <div className="container">
                                        <Login/>
                                    </div>
                                </Route>
                                <Route exact path="/direct">
                                    <div className="container">
                                        <Direct/>
                                    </div>
                                </Route>
                                <Route exact path="/login">
                                    <div className="container">
                                        <Login/>
                                    </div>
                                </Route>
                                <Route exact path="/register">
                                    <Register/>
                                </Route>
                            </div>
                        </div>
                    </div>
                </Router>
            </div>
        );
    }
}

export default App;